var newsletter = new function() {

    var me = this;

    this.bindEvents = function() {
        $("[data-form-newslettersubscribe]").bind("submit", function() {
            var form = $(this);
            var params = {
              'email': form.find("input[type='email']").val(),
              '_token': window.Laravel.csrfToken
            };
            if($(this).valid()){
              $.post("/module/newsletter/subscribe",params, function(response) {
                  if(parseInt(response.code) == 1)
                    form.find("input[type='email']").val('');
                  $("[data-form-newslettermsg]").html(response.msg);
              },"json");
            }
            return false;
        });
    };
}

$(document).ready(function() {
    newsletter.bindEvents();
});
